var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"actual-costs"},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v(" Produktionskosten ")]),_c('v-expansion-panel-content',[_c('ProductionCosts',{attrs:{"data":_vm.data}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }